import { gql } from '@apollo/client';
import { DocumentNode } from 'graphql';

export const CREATE_INTENT: DocumentNode = gql`
  mutation CreateSubscriptionIntent {
    createSubscriptionIntent
  }
`;

export const MAKE_SUBSCRIPTION: DocumentNode = gql`
  mutation MakeSubscription(
    $paymentMethodId: String!
    $paymentMethodSource: String!
    $promotionCode: String
    $financialPaymentId: String
    $paymentMetadata: PaymentMetadataInput
  ) {
    makeSubscriptionV3(
      paymentMethodId: $paymentMethodId
      promotionCode: $promotionCode
      paymentMethodSource: $paymentMethodSource
      financialPaymentId: $financialPaymentId
      paymentMetadata: $paymentMetadata
    ) {
      id
    }
  }
`;

export const UPDATE_SUBSCRIPTION: DocumentNode = gql`
  mutation UpdateSubscription(
    $paymentMethodId: String!
    $paymentMethodSource: String!
    $financialPaymentId: String
  ) {
    updateSubscription(
      paymentMethodId: $paymentMethodId
      paymentMethodSource: $paymentMethodSource
      financialPaymentId: $financialPaymentId
    )
  }
`;

export const GET_UPCOMING_INVOICE: DocumentNode = gql`
  query GetUpcomingInvoice {
    getUpcomingInvoice {
      status
      start_date
      current_period_end
      current_period_start
      cancel_at
      cancel_at_period_end
      total
      plan_id
      trial_start
      trial_end
      due_since
      due_invoices_count
      total_dues
    }
  }
`;

export const GET_LAST_INVOICE: DocumentNode = gql`
  query GetLastInvoice {
    getLastInvoice {
      total
    }
  }
`;

export const GET_CURRENT_PAYMENT_METHOD: DocumentNode = gql`
  query GetCurrentPaymentMethod {
    getCurrentPaymentMethod {
      ... on Card {
        id
        brand
        exp_year
        exp_month
        last4
        source
      }
      ... on BankAccount {
        id
        bank_code
        last4
        source
      }
      ... on PaymentTokenAccount {
        id
        email
        source
      }
      paymentType: __typename
    }
  }
`;

export const GET_CURRENT_PAYMENT_METHODS: DocumentNode = gql`
  query GetCurrentPaymentMethods {
    getCurrentPaymentMethods {
      ... on Card {
        id
        brand
        exp_year
        exp_month
        last4
        source
      }
      ... on BankAccount {
        id
        bank_code
        last4
        source
      }
      ... on PaymentTokenAccount {
        id
        email
        source
      }
      paymentType: __typename
    }
  }
`;

export const VALIDATE_SUBSCRIPTION_PROMOTION_CODE: DocumentNode = gql`
  mutation ValideSubscriptionPromotionCode($promotionCode: String!) {
    validateSubscriptionPromotionCode(promotionCode: $promotionCode) {
      id
      code
      amountOff: amount_off
      percentOff: percent_off
    }
  }
`;

export const ATTACH_PAYMENT_METHOD: DocumentNode = gql`
  mutation AttachPaymentMethod(
    $paymentMethodId: String!
    $paymentMethodSource: String
    $financialPaymentId: String
  ) {
    attachPaymentMethod(
      paymentMethodId: $paymentMethodId
      paymentMethodSource: $paymentMethodSource
      financialPaymentId: $financialPaymentId
    ) {
      ... on Card {
        brand
        exp_year
        exp_month
        last4
      }
      ... on BankAccount {
        bank_code
        last4
      }
      paymentType: __typename
    }
  }
`;

export const DETACH_PAYMENT_METHOD: DocumentNode = gql`
  mutation DetachPaymentMethod(
    $paymentMethodId: String!
    $paymentMethodSource: String!
  ) {
    detachPaymentMethod(
      paymentMethodId: $paymentMethodId
      paymentMethodSource: $paymentMethodSource
    )
  }
`;

export const ASSIGN_PRIMARY_PAYMENT_METHOD: DocumentNode = gql`
  mutation AssignPrimaryPaymentMethod(
    $paymentMethodId: String!
    $paymentMethodSource: String!
  ) {
    assignPrimaryPaymentMethod(
      paymentMethodId: $paymentMethodId
      paymentMethodSource: $paymentMethodSource
    ) {
      success
    }
  }
`;

export const CREATE_PAYMENT_TOKEN = gql`
  mutation CreatePaymentToken($paymentTokenType: PaymentTokenType!) {
    createPaymentToken(paymentTokenType: $paymentTokenType) {
      authorizationToken
    }
  }
`;

export const AUTHORIZE_PAYMENT_TOKEN = gql`
  mutation AuthorizePaymentToken(
    $token: String!
    $paymentTokenType: PaymentTokenType!
  ) {
    authorizePaymentToken(token: $token, paymentTokenType: $paymentTokenType) {
      token
    }
  }
`;

export const START_APPLE_PAY_SESSION = gql`
  mutation StartApplePaySession(
    $validationUrl: String
    $clientOrigin: ApplePayClientOrigin!
  ) {
    startApplePaySession(
      validationUrl: $validationUrl
      clientOrigin: $clientOrigin
    ) {
      session
    }
  }
`;
